// extracted by mini-css-extract-plugin
module.exports = {"container":"Popup_container__2-O1H","component":"Popup_component__1hkBu"};